export default "__VITE_ASSET__gimMT3FC__"